import { useContext } from "react"
import { useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"
import { GlobalContext } from "../Context/globalContext"
import { ChangePasswordApi, UpdateEmailApi } from "../Services/userServices"

export const Profile = () => {

    const [password, set_password] = useState({ old_pwd: '', new_pwd: '', new_pwd2: '' })
    const globalContext = useContext(GlobalContext);
    const navigate = useNavigate();
    const [email, set_email] = useState(globalContext.email);

    const updatePassword = () => {
        if (password.old_pwd.trim() === '') {
            toast.error('Please enter old password.')
            return false
        }
        else if (password.new_pwd.trim() === '') {
            toast.error('Please enter new password.')
            return false
        }
        else if (password.new_pwd2.trim() === '') {
            toast.error('Please confirm new password.')
            return false
        }
        else if (password.new_pwd !== password.new_pwd2) {
            toast.error('New password and confirm password should be same.')
            return false
        }
        else {
            var params = {
                'old_password': password.old_pwd,
                'new_password': password.new_pwd
            }
            globalContext.setLoader(true);
            ChangePasswordApi(params).then(res => {
                globalContext.setLoader(false);
                set_password({ old_pwd: '', new_pwd: '', new_pwd2: '' })
                toast.success(res.data.message)
            }).catch(err => {
                globalContext.setLoader(false);
                if (err.response.status == 401) {
                    sessionStorage.clear();
                    globalContext.setLoggedIn(false);
                    navigate('/');
                    setTimeout(() => { toast.error('Session Expired!'); }, 500);
                    return false
                }
                toast.error(err.response.data.message)
            })
        }
    }

    const updateEmail = () => {
        toast.dismiss()
        var re = /^[a-zA-Z0-9._%+-]+@[a-z0-9]+\.[a-z]{2,10}(\.[a-z]{2,10})?(\.[a-z]{2,10})?(\.[a-z]{2,10})?(\.[a-z]{2,10})?$/;
        if (email.trim() === '') {
            toast.error('Please enter email.')
            return false
        }
        else if (!re.test(email)) {
            toast.error('Please enter valid email.')
            return false
        }
        else {
            var params = {
                'email': email
            }
            globalContext.setLoader(true);
            UpdateEmailApi(params).then(res => {
                globalContext.setLoader(false);
                sessionStorage.setItem('email', res.data.data.email);
                set_email(res.data.data.email)
                toast.success(res.data.message);
            }).catch(err => {
                globalContext.setLoader(false);
                if (err.response.status == 401) {
                    sessionStorage.clear();
                    globalContext.setLoggedIn(false);
                    navigate('/');
                    setTimeout(() => { toast.error('Session Expired!'); }, 500);
                    return false
                }
                toast.error(err.response.data.message)
            })
        }
    }

    return (
        <main id="main" className="main">
            <section className="section dashboard">
                <Form>
                    <Row>
                        <Col className="text-left" md={12}>
                            <label className="my-3">CHANGE EMAIL:</label>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Control type="text" value={email} onChange={(e) => set_email(e.target.value)} placeholder="Enter Email" className="input100" />
                            </Form.Group>
                        </Col>
                        <Col className="text-left" md={12}>
                            <Button onClick={(e) => updateEmail(e)}>Update</Button>
                        </Col>
                    </Row>
                </Form>
                <Form>
                    <Row>
                        <Col className="text-left" md={12}>
                            <label className="my-3">CHANGE PASSWORD:</label>
                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Control type="password" value={password.old_pwd} onChange={(e) => set_password({ ...password, old_pwd: e.target.value })} placeholder="Enter Current Password" className="input100" />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3 mt-2" controlId="formBasicNewPassword">
                                <Form.Control type="password" value={password.new_pwd} onChange={(e) => set_password({ ...password, new_pwd: e.target.value })} placeholder="Enter New Password" className="input100" />
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3 mt-2" controlId="formBasicNewPassword2">
                                <Form.Control type="password" value={password.new_pwd2} onChange={(e) => set_password({ ...password, new_pwd2: e.target.value })} placeholder="Confirm New Password" className="input100" />
                            </Form.Group>
                        </Col>
                        <Col className="text-left" md={12}>
                            <Button onClick={(e) => updatePassword(e)}>Update</Button>
                        </Col>
                    </Row>
                </Form>
            </section>
        </main>
    )

}